import EChartsReact from 'echarts-for-react'
import React from 'react'

interface Iprops {
    lineData: number[][]
    points?: number[][]
    title?: string
    tooltipXLabel?: string
    tooltipYLabel?: string

    t2: [number, number]
    t3: [number, number]
    t4: [number, number]
}

export default function LinePointChart(props: Iprops) {


    const options = {
        backgroundColor: 'rgba(1, 1, 1, 0)',
        title: {
            text: props.title || "",
            left: "left",
            textStyle: {
                fontSize: "20px",
                color: "#0C51C8",
                fontWeight: 400,
            },
            backgroundColor: "#fff",
            padding: [8, 10, 4, 10],
            borderRadius: [8, 0, 0, 0]
        },
        tooltip: {
            trigger: "axis",
            formatter: function (params) {
                let xValue = params[0].data[0];
                let yValue = params[0].data[1];
                let res = `${(props?.tooltipXLabel || "X")}: ${xValue}
                        <br/>
                        ${(props?.tooltipYLabel || "Y")}: ${yValue}`
                return res;
            }
        },
        xAxis: {
            type: 'value',
            name: props?.tooltipXLabel || "x",
            nameLocation: "middle",
            nameGap: 20,
            nameTextStyle: {
                fontSize: "12px",
                fontWeight: 400,
                verticalAlign: 'top',
                color: "#568AE5"
            },
            axisLine: {
                lineStyle: {
                    color: '#005DFF', // X轴颜色
                    width: 3,
                },
                symbol: ['none', 'arrow'], // 在X轴的正方向上添加箭头
                symbolSize: [12, 15], // 箭头大小
                symbolOffset: [0, 10]
            },
            axisLabel: {
                color: '#568AE5', // X轴标签颜色
            },
            axisTick: {
                alignWithLabel: true, // 使刻度线与标签对齐
            },
        },
        yAxis: {
            type: 'value',
            name: props?.tooltipYLabel || "y",
            nameLocation: "end",
            nameGap: 20,
            nameTextStyle: {
                fontSize: "12px",
                fontWeight: 400,
                verticalAlign: 'top',
                color: "#568AE5"
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#005DFF', // Y轴颜色
                    width: 3
                },
                symbol: ['none', 'arrow'], // 在Y轴的正方向上添加箭头
                symbolSize: [12, 15], // 箭头大小
                symbolOffset: [0, 10]
            },
            axisLabel: {
                color: '#568AE5', // Y轴标签颜色
            },
            splitLine: {
                lineStyle: {
                    color: '#D4E1F6', // Y轴网格线颜色
                    width: 1,
                    type: "dashed"
                },
                interval: 1
            },
            axisTick: {
                alignWithLabel: true, // 使刻度线与标签对齐
            },
        },
        grid: {
            left: '3%',   // 调整左边距
            right: '8%',  // 调整右边距
            top: '25%',   // 调整上边距
            bottom: '15px', // 调整下边距
            containLabel: true  // 防止标签溢出容器
        },
        series: [
            {
                data: props.lineData,
                type: 'line',
                smooth: true, // 曲线是否平滑
                lineStyle: {
                    color: '#1B7EF2', // 折线颜色
                    width: 2, // 折线宽度
                },
                showSymbol: false, // 显示数据点
                emphasis: {
                    focus: 'series',
                    itemStyle: {
                        color: '#1B7EF2', // 鼠标悬停时数据点的颜色
                    },
                },
                markArea: {
                    silent: true, // 设置为true以禁止点击触发事件
                    data: [
                        [{
                            xAxis: Number.MIN_VALUE, // 区域起始点
                            itemStyle: {
                                color: "rgba(0, 178, 255, 0.12)"
                            }
                        }, {
                            xAxis: props.t2[0], // 区域结束点
                        }],
                        // t2
                        [{
                            xAxis: props.t2[0], // 区域起始点
                            itemStyle: {
                                color: "rgba(255, 245, 0, 0.12)"
                            }
                        }, {
                            xAxis: props.t2[1], // 区域结束点
                        }],
                        // t3
                        [{
                            xAxis: props.t3[0], // 区域起始点
                            itemStyle: {
                                color: "rgba(242, 105, 27, 0.12)"
                            }
                        }, {
                            xAxis: props.t3[1], // 区域结束点
                        }],
                        // t4
                        [{
                            xAxis: props.t4[0], // 区域起始点
                            itemStyle: {
                                color: "rgba(255, 0, 0, 0.12)"
                            }
                        }, {
                            xAxis: props.t4[1], // 区域结束点
                        }],
                    ]
                },
                markLine: {
                    symbol: "none",
                    data: [
                        {
                            slient: false,
                            lineStyle: {
                                type: "dashed",
                                color: "#FFA800",
                                width: 2
                            },
                            xAxis: props.t2[0],
                            label: {
                                show: false,
                                position: "start",
                                formatter: '预警',
                                color: '#fff',  // 标签文字颜色
                                fontSize: 20,   // 标签文字大小
                                fontWeight: 'bold', // 标签字体粗细
                                backgroundColor: '#EC9C00',  // 标签背景颜色
                                borderRadius: 8, // 标签圆角
                                padding: [4, 8], // 标签内边距
                                rotate: 0,  // 标签旋转角度
                                offset: [0, 12]
                            },
                        },
                        {
                            slient: false,
                            lineStyle: {
                                type: "dashed",
                                color: "#FF6B00",
                                width: 2
                            },
                            xAxis: props.t3[0],
                            label: {
                                show: false,
                                position: 'start',
                                formatter: '危险',
                                color: '#fff',  // 标签文字颜色
                                fontSize: 20,   // 标签文字大小
                                fontWeight: 'bold', // 标签字体粗细
                                backgroundColor: '#F26600',  // 标签背景颜色
                                borderRadius: 8, // 标签圆角
                                padding: [4, 8], // 标签内边距
                                rotate: 0,  // 标签旋转角度
                                offset: [0, 12]
                            },
                        },
                        {
                            slient: false,
                            lineStyle: {
                                type: "solid",
                                color: "#F21B1B",
                                width: 2
                            },
                            xAxis: props.t4[0],
                            label: {
                                show: false,
                                position: "start",
                                formatter: '危险',
                                color: '#fff',  // 标签文字颜色
                                fontSize: 20,   // 标签文字大小
                                fontWeight: 'bold', // 标签字体粗细
                                backgroundColor: '#F21B1B',  // 标签背景颜色
                                borderRadius: 8, // 标签圆角
                                padding: [4, 8], // 标签内边距
                                rotate: 0,  // 标签旋转角度
                                offset: [0, 12]
                            },
                        }
                    ]
                },

            },
            {
                data: props.points,
                type: 'scatter',
                symbol: 'circle', // 设置点的形状为圆形
                symbolSize: 8, // 设置点的大小
                itemStyle: {
                    color: '#fff', // 设置填充色为白色（空心效果）
                    borderColor: '#1B7EF2', // 设置边框颜色
                    borderWidth: 3 // 设置边框宽度
                }
            },
        ],
    }



    return (
        <>
            <EChartsReact
                className="tncet-echart"
                style={{
                    background: "linear-gradient(180deg, #E0ECFF 0%, #FFF 100%)",
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px"
                }}
                option={options}
            />
        </>
    )
}
